module.exports = __webpack_public_path__ + "static/media/banner_escritorio.aee43a50.png";